import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle, ArrowLeft, RefreshCw } from "lucide-react";

const SubscriptionFailure = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
      <div className="bg-white max-w-md w-full rounded-[2rem] p-8 shadow-xl shadow-slate-200/50 flex flex-col items-center text-center border border-slate-100">
        <div className="w-20 h-20 bg-red-50 rounded-full flex items-center justify-center mb-6 ring-4 ring-red-100 animate-pulse">
          <XCircle className="w-10 h-10 text-red-500" />
        </div>
        
        <h1 className="text-2xl font-black text-slate-900 mb-3 uppercase tracking-tight">
          Payment Unsuccessful
        </h1>
        
        <p className="text-slate-600 font-medium mb-6 px-2">
          Your payment was cancelled or could not be completed at this time. No charges were made.
        </p>
        
        <div className="flex flex-col gap-3 w-full">
          <button 
            onClick={() => navigate("/subscription-pricing")}
            className="w-full flex items-center justify-center gap-2 bg-[#247E45] text-white font-bold py-3 px-6 rounded-xl shadow-lg shadow-[#247E45]/25 hover:bg-[#1b6136] transition-all transform hover:-translate-y-0.5 active:translate-y-0"
          >
            <RefreshCw className="w-4 h-4" />
            Try Again / View Plans
          </button>
          
          <button 
            onClick={() => navigate("/")}
            className="w-full flex items-center justify-center gap-2 bg-slate-100 text-slate-700 font-bold py-3 px-6 rounded-xl hover:bg-slate-200 transition-all transform hover:-translate-y-0.5 active:translate-y-0 border border-slate-200"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionFailure;
